import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {IPhotoContent} from '../../../models/photo.model';
import {Title} from '@angular/platform-browser';
import {NewsService} from '../../../service/news.service';
import {ActivatedRoute} from '@angular/router';
import {HttpClient} from '@angular/common/http';

@Component({
  selector: 'app-sailing',
  templateUrl: './sailing.component.html',
  styleUrls: ['./sailing.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class SailingComponent implements OnInit {
  PhotoContent: IPhotoContent[] = [];

  constructor(
    private titleService: Title,
    private APIPhotoService: NewsService,
    private route: ActivatedRoute,
    private http: HttpClient,
  ) {
    this.titleService.setTitle('Alexander Koenig - Segeln');
  }


  ngOnInit() {


    /*this.APIPhotoService.photoData().subscribe(images => {

        //images = images.filter((d) => d.category === this.route.url['_value'][1]['path'] );
        console.log(images, this.route.url['_value'][1]['path']);
        const filteredArr = images.reduce((acc, current) => {
            //
            console.log('filter', acc, current);
            const x = acc.find(item => item.subcategory === current.subcategory);
            if (!x) {
                console.log(':::', acc);
                return acc.concat([current]);
            } else {
                return acc;
            }
        }, []);
        this.PhotoContent = filteredArr;
    });
    */


    return this.APIPhotoService.photoData().subscribe(response => {
      console.log(response);
      response = response.filter((d) =>
        d.category === this.route.url['_value'][1]['path']
      );

      for (let i = 0; i < response.length; i++) {
        const cat = response[i];

        if (this.PhotoContent.find((c) =>
          c.name === cat.name &&
          c.image === cat.image &&
          c.category === cat.category &&
          c.alt === cat.alt &&
          c.IClass === cat.IClass &&
          c.imageLg === cat.imageLg &&
          c.imageMd === cat.imageMd &&
          c.imageSm === cat.imageSm &&
          c.title === cat.title &&
          c.categorycontent === cat.categorycontent &&
          c.headerContent === cat.headerContent
        ) === undefined) {
          this.PhotoContent.push({
            name: cat.name,
            image: cat.image,
            category: cat.category,
            alt: cat.alt,
            IClass: cat.IClass,
            imageLg: cat.imageLg,
            imageMd: cat.imageMd,
            imageSm: cat.imageSm,
            headerContent: cat.headerContent,
            categorycontent: cat.categorycontent,
            title: cat.title
          });
        }
      }
    });
  }

}


